import CheckboxDropdown from "components/checkbox-dropdown/CheckboxDropdown";
import ColorCheckbox from "../../../color-checkbox/ColorCheckbox";
import messages from "messages";
import { AmplitudePageName, track } from "utils/amplitude";
import { useBlockedIntervals } from "components/Dashboard/DoctorDashboard/views/one-one-sessions/contexts/BlockedIntervalsContext";

interface BlockedIntervalsToggleProps {
  analyticsPageName: AmplitudePageName;
}

const BlockedIntervalsToggle = ({
  analyticsPageName,
}: BlockedIntervalsToggleProps) => {
  const { showBlockedIntervals, setShowBlockedIntervals } =
    useBlockedIntervals();

  return (
    <CheckboxDropdown
      Label={messages.blocks}
      onClick={() => {
        track(analyticsPageName, "blocked-intervals-toggle", "click");
        setShowBlockedIntervals((prev) => !prev);
      }}
      Checkbox={
        <ColorCheckbox
          color={showBlockedIntervals ? "#828282" : "none"}
          backgroundColor={showBlockedIntervals ? "#DFDFDF" : "none"}
          stroke={showBlockedIntervals ? "#DFDFDF" : "var(--gray02)"}
        />
      }
    />
  );
};

export default BlockedIntervalsToggle;
